
export function getInBox({
    disableMyChartMenuItems,
    isMedicalAdvice,
    isMyChartUser
}) {

    return {
        show: isMyChartUser,
        disabled: disableMyChartMenuItems,
        navHead: {
            label: 'Communications',
            url: null,
            icon: 'message'
        },
        navItems: [
            {
                label: 'Messages',
                show: isMyChartUser,
                disabled: disableMyChartMenuItems,
                url: '/messagesAll',
                subMenuItems: null
            },
             {
                 label: 'Send a Message',
                 show: isMyChartUser && isMedicalAdvice,
                 disabled: disableMyChartMenuItems,
                 url: '/messagesSend',
                 subMenuItems: null
             },
            {
                label: 'Letters',
                show: isMyChartUser,
                disabled: disableMyChartMenuItems,
                url: '/letters',
                subMenuItems: null
            },
        ]
    };
}
